import { AccountSettingsStoreSlice } from './types';

export const defaultMyAccountState: AccountSettingsStoreSlice['myAccountPage'] =
  {
    pronoun: 'm',
    showPronoun: false,
    birthday: {
      canChange: false,
      dateOfBirth: '',
      display: 'none',
    },
    countryId: 0,
    countries: [],
    measurements: 'metric',
    usernameRename: {
      isRenameEligible: false,
      hasRecentRename: false,
    },
    canUpdateEmail: false,
  };

export const defaultBrowsingState: AccountSettingsStoreSlice['browsingPage'] = {
  theatreView: 'zoomed_out',
  invisibleBrowsing: false,
  browseLimit: 0,
  browseLimitList: [],
  browsePagingMode: 'infinite',
  contentFilter: 'standard',
  contentFilterList: [],
  showAi: false,
  blacklistedTags: [],
};

export const defaultSecurityState: AccountSettingsStoreSlice['securityPage'] = {
  twoFactorAuthentication: {
    canEnable: false,
    enabled: false,
    confirmed: false,
    secretUrl: '',
    secret: '',
  },
  sessions: [],
  blockedUsers: [],
};

export const defaultNotificationsState: AccountSettingsStoreSlice['notificationsPage'] =
  {
    email: {
      accountActivity: false,
      news: false,
      passwordReset: false,
    },
    deviantart: {
      mentions: false,
      badges: false,
      deviantartProtect: false,
      newMembers: false,
    },
  };

export const defaultPromosState: AccountSettingsStoreSlice['promosPage'] = {
  banners: {
    deviationPageBanner: false,
    profileCoverBanner: false,
  },
};

export const defaultPersonalDataState: AccountSettingsStoreSlice['personalDataPage'] =
  {
    isDeactivated: false,
    isPersonaldataRequestInitiated: false,
    isRemoveRequestInitiated: false,
    isRemoveRequestInProgress: false,
    isGdprLinkSent: false,
  };

export const defaultDeactivationState: AccountSettingsStoreSlice['deactivationStatus'] =
  {
    canReactivate: false,
    timeUntilReactivation: 0,
  };
